import { useEffect, useState } from 'react';
import { getCancellationTerms } from '../api';

// Owner Bookings & Cancellation v2 doc, Story 11 - the *resolved* cancellation terms for this
// specific item's owner (their negotiated override if one exists, else the platform default),
// shown before booking rather than a generic T&C paragraph, so what's shown here always matches
// what's actually enforced if the customer later cancels (Legal & regulatory review issue #3).
export default function CancellationPolicy({ itemId }) {
  const [terms, setTerms] = useState(null);
  const [loading, setLoading] = useState(false);
  const [fetchFailed, setFetchFailed] = useState(false);
  const [retry, setRetry] = useState(0);

  useEffect(() => {
    if (!itemId) return;
    let cancelled = false;
    setLoading(true);
    setFetchFailed(false);
    getCancellationTerms(itemId)
      .then((data) => { if (!cancelled) { setTerms(data); setLoading(false); } })
      .catch(() => { if (!cancelled) { setFetchFailed(true); setLoading(false); } });
    return () => { cancelled = true; };
  }, [itemId, retry]);

  if (loading) return (
    <div className="small text-muted border rounded p-2 mb-3">Loading cancellation and refund terms…</div>
  );

  if (fetchFailed) return (
    <div className="small text-danger border rounded p-2 mb-3 d-flex align-items-center gap-2">
      <span>Could not load cancellation terms.</span>
      <button type="button" className="btn btn-sm btn-outline-secondary py-0" onClick={() => setRetry((n) => n + 1)}>Retry</button>
    </div>
  );

  if (!terms) return null;

  const windowDays = terms.refundWindowHours / 24;
  const windowLabel = windowDays >= 1 ? `${windowDays % 1 === 0 ? windowDays : windowDays.toFixed(1)} day(s)` : `${terms.refundWindowHours} hour(s)`;

  return (
    <div className="small text-muted border rounded p-2 mb-3">
      <div className="fw-semibold mb-1">Cancellation and refunds</div>
      <div>Free cancellation up to {windowLabel} before the rental starts.</div>
      <div>After that, a portion of the rental amount is forfeited on a published schedule (up to {Math.round(terms.cancellationMaxForfeitRate * 100)}%).</div>
      <div>The platform fee is not refunded.</div>
    </div>
  );
}
